
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialPaymentGrid extends Serenity.EntityGrid<MaterialPaymentRow, any> {
        protected getColumnsKey() { return 'Sales.MaterialPayment'; }
        protected getDialogType() { return MaterialPaymentDialog; }
        protected getIdProperty() { return MaterialPaymentRow.idProperty; }
        protected getInsertPermission() { return MaterialPaymentRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialPaymentRow.localTextPrefix; }
        protected getService() { return MaterialPaymentService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[42].AutoPosting;
            var voucherNo = FormatHelper.GetVoucherNo(42);


            this.editItem(<MaterialPaymentRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 42,
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}